module.exports = __webpack_public_path__ + "static/img/brees-2003-top-image-thumb.345c964.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2003-top-image-thumb.jpg
// module id = xyzQ
// module chunks = 1